<template>
  <div>
    <p v-if="errorKey" class="errorText">
      {{ $t(`inputErrors.${errorKey}`, { maxLines: maxLines }) }}
    </p>
    <textarea
      v-autosize
      class="optionInput oi-dedication"
      name="dedication"
      rows="1"
      :placeholder="placeholder"
      :value="text"
      @input="
        $emit('input', $event.target.value)
        validateInput($event)
      "
      v-if="maxLines !== 1"
      :class="{ errorInput: errorKey !== '' }"
    ></textarea>
    <input
      type="text"
      class="optionInput oi-dedication"
      :placeholder="placeholder"
      :value="text"
      @input="
        $emit('input', $event.target.value)
        validateInput($event)
      "
      v-if="maxLines == 1"
      :class="{ errorInput: errorKey !== '' }"
    />
  </div>
</template>

<script>
import {
  filterIllegalCharacters,
  filterTooLongLines,
  filterTooManyLines,
} from '../../util/filterInput.js'
import { trackProblemEvent } from '../../util/tracker'

export default {
  name: 'TextInput',
  props: {
    text: String,
    maxCharsPerLine: {
      type: Number,
      required: false,
      default: 60,
    },
    maxLines: {
      type: Number,
      required: false,
      default: 1,
    },
    placeholder: String,
    name: String
  },
  data() {
    return {
      errorKey: '',
    }
  },
  methods: {
    validateInput: function(e) {
      const inputString = e.target.value

      if (filterIllegalCharacters(inputString) !== inputString) {
        this.errorKey = 'illegalCharacter'
      } else if (
        filterTooManyLines(inputString, this.maxLines) !== inputString
      ) {
        this.errorKey = 'maxLines'
      } else if (
        filterTooLongLines(inputString, this.maxCharsPerLine) !== inputString
      ) {
        this.errorKey = 'lineTooLong'
      } else {
        this.errorKey = ''
      }

      if (this.errorKey) {
        trackProblemEvent('TextInput', this.errorKey)
      }
    },
  },
}
</script>
